/**
 * Motion Effects Handler
 *
 * @author Nhamdv
 * Code is poetry
 */
export default class MotionEffects extends elementorModules.frontend.handlers.Base {
	__construct() {
		super.__construct( ...arguments );
		this.toggle = elementorFrontend.debounce( this.toggle, 200 );
	}

	onInit() {
		super.onInit();

		this.effects = {
			mouseTrack: {
				interaction: 'mouseMove',
				actions: [ 'translateXY' ],
			},
			tilt: {
				interaction: 'mouseMove',
				actions: [ 'tilt' ],
			},
		};

		this.toggle();
	}

	getDefaultSettings() {
		return {
			selectors: {
				container: '.elementor-widget-container',
			},
		};
	}

	getDefaultElements() {
		const selectors = this.getSettings( 'selectors' );
		return {
			$container: this.$element.find( selectors.container ),
		};
	}

	bindEvents() {
		elementorFrontend.elements.$window.on( 'resize', this.toggle );
	}

	unbindEvents() {
		elementorFrontend.elements.$window.off( 'resize', this.toggle );
	}

	prepareOptions( name ) {
		const elementSettings = this.getElementSettings(),
			interactions = {};

		jQuery.each( elementSettings, ( key, value ) => {
			const keyRegex = new RegExp( 'thim_ekit_' + name + '_(.+)_effect' ),
				keyMatches = key.match( keyRegex );

			if (! keyMatches || ! value || value === 'no') {
				return;
			}

			const options = {},
				effectName = keyMatches[1];

			jQuery.each( elementSettings, ( subKey, subValue ) => {
				const subKeyRegex = new RegExp( 'thim_ekit_' + name + '_' + effectName + '_(.+)' ),
					subKeyMatches = subKey.match( subKeyRegex );

				if (! subKeyMatches) {
					return;
				}
				const subFieldName = subKeyMatches[1];
				if ('effect' === subFieldName) {
					return;
				}
				if ('object' === typeof subValue) {
					subValue = Object.keys( subValue.sizes ).length ? subValue.sizes : subValue.size;
				}
				options[subKeyMatches[1]] = subValue;
			} );

			const effect = this.effects[effectName],
				interactionName = effect.interaction;

			if (! interactions[interactionName]) {
				interactions[interactionName] = {};
			}
			effect.actions.forEach( ( action ) => interactions[interactionName][action] = options );
		} );

		let $element = this.$element,
			$dimensionsElement;
		const elementType = this.getElementType();
 		if (! [ 'section', 'container' ].includes( elementType )) {
			$dimensionsElement = $element;
			let childElementSelector;

			if ('column' === elementType) {
				childElementSelector = '.elementor-widget-wrap';
			} else {
				childElementSelector = '.elementor-widget-container';
			}
			$element = $element.find( '> ' + childElementSelector );
 		}

		const options = {
			interactions,
			elementSettings,
			$element,
			$dimensionsElement,
			classes: {
				element: 'thim-ekit-motion-fx-element',
				parent: 'thim-ekit-motion-fx-parent',
				container: 'thim-ekit-motion-fx-container',
			},
		};

		return options;
	}

	activate( name ) {
		const options = this.prepareOptions( name );

		if (jQuery.isEmptyObject( options.interactions )) {
			return;
		}
		this[name] = new MotionFx( options );
	}

	deactivate( name ) {
		if (this[name]) {
			this[name].destroy();
			delete this[name];
		}
	}

	toggle() {
		const currentDeviceMode = elementorFrontend.getCurrentDeviceMode(),
			elementSettings = this.getElementSettings();

		[ 'motion_fx', 'background_motion_fx' ].forEach( ( name ) => {
			const devices = elementSettings[name + '_devices'],
				isCurrentModeActive = ! devices || -1 !== devices.indexOf( currentDeviceMode );

			if (isCurrentModeActive && ( elementSettings['thim_ekit_' + name + '_mouse'] )) {
				if (this[name]) {
					this.refreshInstance( name );
				} else {
					this.activate( name );
				}
			} else {
				this.deactivate( name );
			}
		} );
	}

	refreshInstance( instanceName ) {
		const instance = this[instanceName];
		if (! instance) {
			return;
		}
		const preparedOptions = this.prepareOptions( instanceName );
		instance.setSettings( preparedOptions );
		instance.refresh();
	}

	onElementChange( propertyName ) {
		if (/motion_fx_((mouse)|(devices))$/.test( propertyName )) {
			this.toggle();
		}

		const propertyMatches = propertyName.match( '(_motion_fx)' );
		if (propertyMatches) {
			const instanceName = 'motion_fx';
			this.refreshInstance( instanceName );
			if (! this[instanceName]) {
				this.activate( instanceName );
			}
		}
	}

	onDestroy() {
		super.onDestroy();

		[ 'motion_fx', 'background_motion_fx' ].forEach( ( name ) => {
			this.deactivate( name );
		} );
	}
}

class MotionFx extends elementorModules.ViewModule {
	getDefaultSettings() {
		return {
			$element: null,
			$dimensionsElement: null,
			interactions: {},
			classes: {
				element: 'thim-ekit-motion-fx-element',
				parent: 'thim-ekit-motion-fx-parent',
				container: 'thim-ekit-motion-fx-container',
			},
		};
	}

	initInteractionsTypes() {
		this.interactionsTypes = {
			mouseMove,
		};
	}

	runInteractions() {
		const _this = this;
		const settings = this.getSettings();
		jQuery.each( settings.interactions, ( interactionName, actions ) => {
			this.interactions[interactionName] = new this.interactionsTypes[interactionName]( {
				motionFX: this,
				callback() {
					const _len = arguments.length,
						args = new Array( _len );

					for (let _key = 0; _key < _len; _key++) {
						args[_key] = arguments[_key];
					}

					jQuery.each( actions, ( actionName, actionData ) => _this.actions.runAction( actionName, actionData, ...args ) );
				},
			} );
			this.interactions[interactionName].run();
		} );
	}

	destroyInteractions() {
		jQuery.each( this.interactions, ( interactionName, interaction ) => interaction.destroy() );
		this.interactions = {};
	}

	refresh() {
		this.actions.setSettings( this.getSettings() );
		this.actions.refresh();
		this.destroyInteractions();
		this.runInteractions();
	}

	destroy() {
		this.destroyInteractions();
		this.actions.refresh();
		const settings = this.getSettings();
		this.$element.removeClass( settings.classes.element );
		this.elements.$parent.removeClass( settings.classes.parent );
	}

	onInit() {
		super.onInit();
		const settings = this.getSettings();
		this.$element = settings.$element;
		this.elements.$parent = this.$element.parent();
		this.$element.addClass( settings.classes.element );
		this.elements.$parent = this.$element.parent();
		this.elements.$parent.addClass( settings.classes.parent );
		settings.$targetElement = this.$element;
		this.interactions = {};
		this.actions = new Actions( settings );
		this.initInteractionsTypes();
		this.runInteractions();
	}
}

class Actions extends elementorModules.Module {
	getStep( passedPercents, options ) {
		return this.getElementStep( passedPercents, options );
	}

	getElementStep( passedPercents, options ) {
		return -( passedPercents - 50 ) * options.speed;
	}

	translateX( actionData, passedPercents ) {
		actionData.axis = 'x';
		actionData.unit = 'px';
		this.transform( 'translateX', passedPercents, actionData );
	}

	translateY( actionData, passedPercents ) {
		actionData.axis = 'y';
		actionData.unit = 'px';
		this.transform( 'translateY', passedPercents, actionData );
	}

	translateXY( actionData, passedPercentsX, passedPercentsY ) {
		this.translateX( actionData, passedPercentsX );
		this.translateY( actionData, passedPercentsY );
	}

	tilt( actionData, passedPercentsX, passedPercentsY ) {
		const options = {
			speed: actionData.speed / 10,
			direction: actionData.direction,
		};
		this.rotateX( options, passedPercentsY );
		this.rotateY( options, 100 - passedPercentsX );
	}

	rotateX( actionData, passedPercents ) {
		actionData.axis = 'x';
		actionData.unit = 'deg';
		this.transform( 'rotateX', passedPercents, actionData );
	}

	rotateY( actionData, passedPercents ) {
		actionData.axis = 'y';
		actionData.unit = 'deg';
		this.transform( 'rotateY', passedPercents, actionData );
	}

	transform( action, passedPercents, actionData ) {
		if (actionData.direction) {
			passedPercents = 100 - passedPercents;
		}
		this.updateRulePart( 'transform', action, this.getStep( passedPercents, actionData ) + actionData.unit );
	}

	updateRulePart( ruleName, key, value ) {
		if (! this.rulesVariables[ruleName]) {
			this.rulesVariables[ruleName] = {};
		}
		if (! this.rulesVariables[ruleName][key]) {
			this.rulesVariables[ruleName][key] = true;
			this.updateRule( ruleName );
		}
		const cssVarKey = `--thim-ekit-${ key }`;
		this.$element[0].style.setProperty( cssVarKey, value );
	}

	updateRule( ruleName ) {
		let value = '';
		value += this.concatTransformMotionEffectCSSProperties( ruleName );
		this.$element.css( ruleName, value );
	}

	concatTransformMotionEffectCSSProperties( ruleName ) {
		let value = '';
		jQuery.each( this.rulesVariables[ruleName], ( variableKey ) => {
			value += `${ variableKey }(var(--thim-ekit-${ variableKey }))`;
		} );
		return value;
	}

	runAction( actionName, actionData, passedPercents ) {
		if (actionData.affectedRange) {
			if (actionData.affectedRange.start > passedPercents) {
				passedPercents = actionData.affectedRange.start;
			}
			if (actionData.affectedRange.end < passedPercents) {
				passedPercents = actionData.affectedRange.end;
			}
		}

		const _len = arguments.length,
			args = new Array( _len > 3 ? _len - 3 : 0 );

		for (let _key = 3; _key < _len; _key++) {
			args[_key - 3] = arguments[_key];
		}
		this[actionName]( actionData, passedPercents, ...args );
	}

	refresh() {
		this.rulesVariables = {};
		this.$element.css( {
			transform: '',
			'will-change': '',
		} );
	}

	onInit() {
		this.$element = this.getSettings( '$targetElement' );
		this.refresh();
	}
}

class mouseMove extends elementorModules.ViewModule {
	constructor() {
		super( ...arguments );

		this.onInsideViewport = () => {
			this.run();
			this.animationFrameRequest = requestAnimationFrame( this.onInsideViewport );
		};
	}

	__construct( options ) {
		this.motionFX = options.motionFX;
		if (! this.intersectionObservers) {
			this.setElementInViewportObserver();
		}
	}

	setElementInViewportObserver() {
		this.intersectionObserver = elementorModules.utils.Scroll.scrollObserver( {
			callback: ( event ) => {
				if (event.isInViewport) {
					this.onInsideViewport();
				} else {
					this.removeAnimationFrameRequest();
				}
			},
		} );

		const observedElement = this.motionFX.elements.$parent[0];
		this.intersectionObserver.observe( observedElement );
	}

	runCallback() {
		const callback = this.getSettings( 'callback' );
		callback( ...arguments );
	}

	removeIntersectionObserver() {
		if (this.intersectionObserver) {
			this.intersectionObserver.unobserve( this.motionFX.elements.$parent[0] );
		}
	}

	removeAnimationFrameRequest() {
		if (this.animationFrameRequest) {
			cancelAnimationFrame( this.animationFrameRequest );
		}
	}

	destroy() {
		this.removeAnimationFrameRequest();
		this.removeIntersectionObserver();
	}

	onInit() {
		super.onInit();
		this.oldMousePosition = {};
		this.mousePosition = {};
	}

	bindEvents() {
		if (! this.mouseTracked) {
			elementorFrontend.elements.$window.on( 'mousemove', ( event ) => {
				this.mousePosition = {
					x: event.clientX,
					y: event.clientY,
				};
			} );
			this.mouseTracked = true;
		}
	}

	run() {
		const mousePosition = this.mousePosition,
			oldMousePosition = this.oldMousePosition;

		if (oldMousePosition.x === mousePosition.x && oldMousePosition.y === mousePosition.y) {
			return;
		}

		this.oldMousePosition = {
			x: mousePosition.x,
			y: mousePosition.y,
		};

		const passedPercentsX = 100 / innerWidth * mousePosition.x,
			passedPercentsY = 100 / innerHeight * mousePosition.y;

		this.runCallback( passedPercentsX, passedPercentsY );
	}
}
